import { AppointmentLeadTime } from '@weave/schema-gen-ts/dist/schemas/analytics-reporting/analytics_gateway/analytics_gateway.pb';
import { AxisGroup } from '@frontend/charts';
import { i18next } from '@frontend/i18n';

export const APPOINTMENT_LEAD_TIME_OPTIONS = [
  {
    label: i18next.t('Same day', { ns: 'analytics' }),
    value: AppointmentLeadTime.LEAD_TIME_0_1_DAYS,
  },
  {
    label: i18next.t('1 to 3 days', { ns: 'analytics' }),
    value: AppointmentLeadTime.LEAD_TIME_1_3_DAYS,
  },
  {
    label: i18next.t('4 to 10 days', { ns: 'analytics' }),
    value: AppointmentLeadTime.LEAD_TIME_4_10_DAYS,
  },
  {
    label: i18next.t('> 10 days', { ns: 'analytics' }),
    value: AppointmentLeadTime.LEAD_TIME_10_PLUS_DAYS,
  },
];

export const APPOINTMENT_LEAD_TIME_Y_AXIS_GROUPS: AxisGroup[] = [
  {
    label: i18next.t('Appointment Lead Time', { ns: 'analytics' }),
    key: 'leadTime',
    icon: 'calendar',
    selectionType: 'radio',
    options: APPOINTMENT_LEAD_TIME_OPTIONS,
  },
];
